import React from 'react';
import SideBarIcon from '../sidebaricon/index';
import Home from './iconsvgs/home';
import Profile from './iconsvgs/profile';
import Skills from './iconsvgs/skills';
import Projects from './iconsvgs/projects';
import Contact from './iconsvgs/contact';
import Blog from './iconsvgs/blog';
// import Mail from '../../assets/images/mail.png';

import {withRouter} from 'react-router-dom';

const sideBarOptions = [
  {
    component: Home,
    text: 'Home',
    url: '/'
  }, {
    component: Profile,
    text: 'About',
    url: '/about'
  }, {
    component: Skills,
    text: 'Skills',
    url: '/skills'
  }, {
    component: Projects,
    text: 'Projects',
    url: '/projects'
  }, {
    component: Contact,
    text: 'Contact',
    url: '/contact'
  }
]

let Index = ({location}) => {
  return (
    <div className="side-bar-ctn">
      <div className="side-bar-icons-ctn">
        {
          sideBarOptions.map((option, index) => <SideBarIcon
          key={index}
          component={option.component}
          text={option.text}
          url={option.url}
          showBorder={location.pathname === option.url}/>)
        }
        <div className={`icon-ctn ${"blog-side-bar-icon"}`}>
          <a href="https://blog.dakshgautam.com" target="_blank" rel="noopener noreferrer">
            <div className={`icon`}>
              <Blog />
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

Index = withRouter(Index);

export default Index;


// WEBPACK FOOTER //
// ./src/components/sidebar/index.js